var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.need_updating)?_c('div',{staticClass:"update-mask"},[_c('p',[_vm._v("软件更新")]),_c('p',[_vm._v("进度："+_vm._s(_vm.progress)+"%")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }